import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { ParticipantCodeForm } from './ParticipantCodeForm'

export const ParticipantCodeLoading = () => {
  const [show, setShow] = useState(false)

  const handleClose = () => {
    setShow(false)
  }
  const handleShow = () => {
    setShow(true)
  }
  return (
    <>
      <Button
        onClick={() => handleShow()}
        aria-controls='CodeLoading'
        className='mobile-btn mb-0 button-pulse btn-primary'
      >
        Bereits registriert?
      </Button>
      <p className="participant-code-modal-hint text-muted"></p>
      <Modal size='lg' show={show} onHide={handleClose}>
        <Modal.Header closeButton closeLabel={'Modal schließen'}>
          <Modal.Title>Persönliche Angaben laden</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Wenn die persönlichen Daten inklusive Zugangscode bereits eingegeben
            worden sind, können hier weitere Anmeldungen zu den bisherigen
            hinzugefügt werden. Geben Sie dazu bitte den Zugangscode, Ihr
            Geburtsdatum und Ihre E-Mail-Adresse ein.
          </p>
          <ParticipantCodeForm setShow={setShow} />
        </Modal.Body>
        <Modal.Footer>
          <Button form='codeForm' type='submit' variant='primary'>
            Daten laden
          </Button>
          <Button variant='secondary' onClick={() => handleClose()}>
            Schließen
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
